export var ERROR_MSG = {
    ADDRESS: {
        MISSING_ADDRESS: function (radius, unit) { return "Please choose an address within the delivery range"; },
        ADDING_ERR: "There was an error adding your address",
        MISSING_DELIVERY_PRICE: "There was an error calculating delivery fee",
        DELETE: "There was an issue deleting your address",
        NOT_STREET_ADDRESS: "Please choose a street address",
        SERVER_ERR: "There was an issue with the chosen address"
    },
    APP: {
        ONLINE_ORDERING_DISABLED: "Online ordering is not available from this store"
    },
    COMMON: {
        MISSING_FIELDS: "Please fill out all mandatory fields"
    },
    ORDER: {
        ORDER_TIME: {
            MISSING_ORDER_TIME: "Please set an order time",
            STORE_CLOSED: "Online orders cannot be accepted for today. However, you may schedule an order for a later date.",
            STORE_LATE_ORDER: "Sorry, but we are closed for now. However, you may schedule an order for later.",
        },
        PAYMENT: {
            CREATION_ERR: "There was an error creating a payment account",
            DELETION_ERR: "There was an error deleting your payment account",
            MISSING_PAYMENT: "Please set a payment method",
            INVALID_EXPIRATION: "Please input a valid expiration date",
            INVALID_CARD_NUMBER: "There was an error validating the card number",
            LOST_ACCOUNT: "There was an error locating the payment account"
        },
        ITEMS: {
            MISSING_ITEMS: "Please add items to your cart"
        },
        SERVICE_TYPE: {
            MISSING_SERVICE_TYPE: "Please choose a service type",
        },
        DELIVERY: {
            UNDER_MINIMUM: function (minimum) { return "Your order total for delivery (excluding tax and delivery fee) is below ($" + minimum + "). Please add more items to meet the delivery minimum or choose pickup."; },
        },
        MISC: {
            CUSTOMER_MISMATCH: "Sorry, you are unable to view this order"
        },
        SERVER_ERR: 'Error: empty message from server',
    },
    PROFILE: {
        MISSING_EMAIL: "Please enter a valid email",
        MISSING_PHONE: "Please enter a valid phone"
    },
    LOCATION: {
        MISSING_LOCATION: "Please choose a store location",
        NONE_AVAILABLE: "Sorry, there are no locations near you",
        UNAVAILABLE: function (phone) {
            if (phone === void 0) { phone = ''; }
            return " Whoops!  We\u2019re having trouble relaying your order to this store. Please try again or call us at (" + phone + ") and we\u2019ll be happy to serve you.";
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/common/messages/error.msg.ts
// module id = vg8l
// module chunks = 18